// Bitcoin Treasury Data based on bitcointreasuries.net
// This data would ideally come from an API, but we'll use static data for now
// Last updated: Based on current bitcointreasuries.net data

export const btcTreasuryData = {
  MSTR: {
    name: 'MicroStrategy',
    ticker: 'MSTR',
    country: 'US',
    btcHoldings: 597325,
    btcPercentOfSupply: 2.844,
    marketCap: 112851, // in millions
    enterpriseValue: 112851,
    btcValue: 65127, // in millions at current price
    costBasis: 42900, // estimated avg purchase price
    purchaseStrategy: 'Aggressive accumulation',
    debtIssuance: true,
    btcPerShare: 3.2,
    navPremium: 73, // trading at premium to BTC holdings
    profitability: 'Mixed',
    leverageRatio: 2.8,
    leadership: 'Michael Saylor - Strong BTC advocate',
    holdingPeriod: 'Long-term (since 2020)',
  },
  MARA: {
    name: 'MARA Holdings (Marathon Digital)',
    ticker: 'MARA',
    country: 'US',
    btcHoldings: 50000,
    btcPercentOfSupply: 0.238,
    marketCap: 6215,
    enterpriseValue: 6215,
    btcValue: 5452,
    costBasis: 28000,
    purchaseStrategy: 'Mining + Treasury',
    debtIssuance: false,
    btcPerShare: 0.18,
    navPremium: 14,
    profitability: 'Volatile',
    leverageRatio: 0.9,
    leadership: 'Fred Thiel - Mining focused',
    holdingPeriod: 'Operational holdings',
  },
  RIOT: {
    name: 'Riot Platforms',
    ticker: 'RIOT',
    country: 'US',
    btcHoldings: 19225,
    btcPercentOfSupply: 0.092,
    marketCap: 4100,
    enterpriseValue: 4500,
    btcValue: 2096,
    costBasis: 31000,
    purchaseStrategy: 'Mining + Treasury',
    debtIssuance: true,
    btcPerShare: 0.065,
    navPremium: 95,
    profitability: 'Negative',
    leverageRatio: 1.8,
    leadership: 'Jason Les - Mining expansion',
    holdingPeriod: 'Mixed operational/investment',
  },
  TSLA: {
    name: 'Tesla',
    ticker: 'TSLA',
    country: 'US',
    btcHoldings: 9720,
    btcPercentOfSupply: 0.046,
    marketCap: 789000,
    enterpriseValue: 768000,
    btcValue: 1060,
    costBasis: 31620,
    purchaseStrategy: 'Strategic reserve',
    debtIssuance: false,
    btcPerShare: 0.003,
    navPremium: -2, // BTC is tiny % of company
    profitability: 'Positive',
    leverageRatio: 0.3,
    leadership: 'Elon Musk - BTC supporter',
    holdingPeriod: 'Long-term reserve',
  },
  COIN: {
    name: 'Coinbase',
    ticker: 'COIN',
    country: 'US',
    btcHoldings: 9480,
    btcPercentOfSupply: 0.045,
    marketCap: 42000,
    enterpriseValue: 35000,
    btcValue: 1034,
    costBasis: 35000,
    purchaseStrategy: 'Operational + Investment',
    debtIssuance: true,
    btcPerShare: 0.04,
    navPremium: 5,
    profitability: 'Cyclical',
    leverageRatio: 0.6,
    leadership: 'Brian Armstrong - Crypto native',
    holdingPeriod: 'Mixed use',
  },
  SQ: {
    name: 'Block (Square)',
    ticker: 'SQ',
    country: 'US',
    btcHoldings: 8027,
    btcPercentOfSupply: 0.038,
    marketCap: 38000,
    enterpriseValue: 40000,
    btcValue: 875,
    costBasis: 29000,
    purchaseStrategy: 'Treasury investment',
    debtIssuance: false,
    btcPerShare: 0.013,
    navPremium: -5,
    profitability: 'Mixed',
    leverageRatio: 0.5,
    leadership: 'Jack Dorsey - BTC maximalist',
    holdingPeriod: 'Long-term',
  },
  HUT: {
    name: 'Hut 8 Corp',
    ticker: 'HUT',
    country: 'CA',
    btcHoldings: 10096,
    btcPercentOfSupply: 0.048,
    marketCap: 2300,
    enterpriseValue: 2800,
    btcValue: 1100,
    costBasis: 25000,
    purchaseStrategy: 'Mining + HODL',
    debtIssuance: true,
    btcPerShare: 0.11,
    navPremium: 109,
    profitability: 'Negative',
    leverageRatio: 1.5,
    leadership: 'Asher Genoot - Mining focus',
    holdingPeriod: 'HODL strategy',
  },
  CLSK: {
    name: 'CleanSpark',
    ticker: 'CLSK',
    country: 'US',
    btcHoldings: 8911,
    btcPercentOfSupply: 0.042,
    marketCap: 3500,
    enterpriseValue: 4000,
    btcValue: 972,
    costBasis: 27000,
    purchaseStrategy: 'Mining accumulation',
    debtIssuance: true,
    btcPerShare: 0.045,
    navPremium: 260,
    profitability: 'Improving',
    leverageRatio: 1.2,
    leadership: 'Zach Bradford - Growth focused',
    holdingPeriod: 'Mining treasury',
  },
  SMLR: {
    name: 'Semler Scientific',
    ticker: 'SMLR',
    country: 'US',
    btcHoldings: 2321,
    btcPercentOfSupply: 0.011,
    marketCap: 280,
    enterpriseValue: 250,
    btcValue: 253,
    costBasis: 42000,
    purchaseStrategy: 'Treasury conversion',
    debtIssuance: false,
    btcPerShare: 0.32,
    navPremium: 10,
    profitability: 'Positive',
    leverageRatio: 0.1,
    leadership: 'Following MSTR playbook',
    holdingPeriod: 'Recent adopter (2024)',
  },
  '3350.T': {
    name: 'Metaplanet',
    ticker: '3350.T',
    country: 'JP',
    btcHoldings: 13350,
    btcPercentOfSupply: 0.064,
    marketCap: 800,
    enterpriseValue: 850,
    btcValue: 1456,
    costBasis: 65000,
    purchaseStrategy: 'Japan\'s MicroStrategy',
    debtIssuance: true,
    btcPerShare: 0.85,
    navPremium: -45,
    profitability: 'Transitioning',
    leverageRatio: 0.8,
    leadership: 'Dylan LeClair advised',
    holdingPeriod: 'New strategy (2024)',
  },
};

// Calculate current BTC price based on MSTR data
export const estimatedBtcPrice = Math.round(
  (btcTreasuryData.MSTR.btcValue * 1000000) / btcTreasuryData.MSTR.btcHoldings
);

// Helper function to get all available tickers
export const getAvailableTickers = () => {
  return Object.keys(btcTreasuryData).sort();
};